const ApiError = {
  Unauthorized: 'notifications.error.unauthorized',
  Forbidden: 'notifications.error.forbidden',
  NotFound: 'notifications.error.notFound',
  Timeout: 'notifications.error.timeout',
  NotAcceptable: 'notifications.error.notAcceptable',
  UnprocessableEntity: 'notifications.error.unprocessableEntity',
  InternalError: 'notifications.error.internal',
  UnknownFailure: 'notifications.error.generic',
  NetworkError: 'notifications.error.networkError',
  EtagMismatch: 'notifications.error.etagMismatch',
  FileUploadFailure: 'notifications.error.fileUpload',
  GenericError: 'notifications.error.delete',
  CannotDeleteInvoicedTransaction: 'notifications.error.cannotDeleteInvoicedTransaction',
  CannotDeleteOrderWithInvoicedTransaction: 'notifications.error.cannotDeleteOrderWithInvoicedTransaction',
  CannotDeleteSubOrderInvoicedTransaction: 'notifications.error.cannotDeleteSubOrderInvoicedTransaction'
}

export default ApiError
